
const getSearchCode = (type) => {
    return `${type.typePrefix}:${type.uuid}`
}

const getBirthType = (typeList) => {
    return typeList.categoriesLv1.find(obj => obj.id === 1)
}

const getBirtOptions = (typeList) => {
    let filteredList = [];

    const birthCatLv1 = getBirthType(typeList);
    const birthCatLv2Types = birthCatLv1.categoryLv2
    
    if (birthCatLv2Types && birthCatLv2Types.length > 0) {
        filteredList.push({ label: 'Todos los cumpleaños', value: birthCatLv1.uuid });
        birthCatLv2Types.forEach((item) => {
            filteredList.push({ label: item.title, value: getSearchCode(item) })
        })
    }
    return filteredList
}

const getPortraitsByCatLv1Id = (decorationPortraits, catLv1Id) => {
    let filteredList = decorationPortraits.filter(item => {
        return item.typeCatLv1Id === catLv1Id
    });
    return filteredList;
}

export {
    getPortraitsByCatLv1Id,
    getBirtOptions,
    getSearchCode
}